import React from 'react';

const RsvpHero: React.FC = () => {
  return (
    <div className="rsvp-hero">
      <div className="rsvp-hero-content">
        <h1>Mariage d'Estelle et Rémi</h1>
        <p>Nous serions ravis de vous compter parmi nous</p>
      </div>
    </div>
  );
};

export default RsvpHero;
